var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"tasks--desktop"},[_c('tbody',[_vm._l((_vm.list),function(task,i){return [(
          !_vm.list[i - 1] ||
          task.project.company.id !== _vm.list[i - 1].project.company.id
        )?_c('HeaderDesktop',{key:("company-" + (task.id)),attrs:{"task":task}}):_vm._e(),_c('TaskDesktop',{key:("task-" + (task.id)),attrs:{"task":task}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }